import { Nullable } from '@/models/type-generators/nullable';

export function generateCsvContent<T>(
  headers: string,
  content: Nullable<T[]> | undefined,
  processLine: (element: T) => string
): string {
  const universalBOM = '\uFEFF';
  let reportCSVLines = '';
  if (content) {
    reportCSVLines = `${content.map(processLine).join('\r\n')}\r\n`;
  }

  return `${universalBOM}${headers}\r\n${reportCSVLines}`;
}
